import React, { createContext, useContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [cookies] = useCookies(["isLoggedIn"]);
    const [isAuthenticated, setIsAuthenticated] = useState(cookies.isLoggedIn === true);

    useEffect(() => {
        setIsAuthenticated(cookies.isLoggedIn === true);
    }, [cookies.isLoggedIn]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
